<template>
    <div class="multilevel" ref="multilevel">
        <el-popover
            placement="bottom-start"
            :width="(width + 24) + 'px'"
            popper-class="multilevel-popover"
            trigger="click" @show="showFun" @hide="show = false">
            <template #reference>
                <div class="m-select" ref="but">
                    <div class="m-value" :style="!formdata && formdata !== 0 ? 'background:transparent;' : ''">
                        <span :class="!formdata ? 'm-no-c' : ''">{{ getShowVal(formdata) }}</span>
                        <el-icon v-if="formdata || formdata === 0" @click.stop="closeValue"><CircleCloseFilled /></el-icon>
                    </div>
                    <i :class="['el-icon-caret-bottom icon-b', show ? 'show-i' : '']" />
                </div>
            </template>
            <div class="m-popover" :style="{width: width + 'px'}">
                <div class="m-popover-search">
                    <el-input class="p-search"
                        placeholder="请输入内容"
                        prefix-icon="Search"
                        size="small"
                        @input="upSearch"
                        v-model="search">
                    </el-input>
                </div>
                <div v-if="levelConfig.length === 0" class="m-no-data">暂无数据</div>
                <div class="m-scroll" v-else>
                    <el-scrollbar class="m-s-s" ref="oneActiveRef">
                        <template v-for="(list, index) in levelConfig">
                            <div v-if="!list.isHide"
                              :key="list.value"
                              :class="['m-list', oneActive === index ? 'm-list-active' : '']"
                              @click="setActive('oneActive', index, list)">
                                <span>{{list.label}}</span>
                                <i v-if="(config.dataType !== 'provinces' || oneActive === index) && list.children && list.children.length > 0" class="el-icon-arrow-right" />
                            </div>
                        </template>
                    </el-scrollbar>
                    <el-scrollbar 
                        class="m-s-s" 
                        ref="twoActiveRef"
                        v-if="(oneActive || oneActive === 0) && 
                            levelConfig && 
                            levelConfig[oneActive] && 
                            levelConfig[oneActive].children"
                    >
                        <template v-for="(item, index) in levelConfig[oneActive].children">
                            <div v-if="!item.isHide && getHide(item, 2)" :key="item.value" :class="['m-list', twoActive === index ? 'm-list-active' : '']" @click="setActive('twoActive', index, item)">
                                <span>{{ item.label }}</span>
                                <i v-if="(config.dataType !== 'provinces' || twoActive === index) && item.children && item.children.length > 0 && config.level !== 2" class="el-icon-arrow-right" />
                            </div>
                        </template>
                    </el-scrollbar>
                    <el-scrollbar ref="threeActiveRef" class="m-s-s" v-if="config.level === 3 && (oneActive || oneActive === 0) && (twoActive || twoActive === 0) && levelConfig[oneActive] && levelConfig[oneActive].children && levelConfig[oneActive].children[twoActive] && levelConfig[oneActive].children[twoActive].children">
                        <template v-for="(it, index) in (levelConfig[oneActive].children && levelConfig[oneActive].children[twoActive].children || [])">
                            <div v-if="!it.isHide && getHide(it, 3)" :key="it.value" :class="['m-list', radioValue[2] && radioValue[2] === it.value ? 'm-list-active' : '']" @click="setActive('threeActive', index, it)">
                                <span>{{it.label}}</span>
                            </div>
                        </template>
                    </el-scrollbar>
                </div>
            </div>
        </el-popover>
    </div>
</template>

<script>
import { getregiondictlist } from '@/port/fromDesigner/index'
export default {
    name: 'multiLevel',
    props: {
        config: {
            type: Object || Array,
            default: () => {}
        },
        formdata: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            width: '',
            show: false,
            radioValue: [],
            levelConfig: [],
            oneActive: '',
            twoActive: '',
            threeActive: '',
            search: ''
        }
    },
    watch: {

    },
    methods: {
        closeValue () {
            this.$emit('update:formdata', '')
            this.$emit('change', '')
            this.radioValue = []
        },
        upSearch (key) {
            // 非省市的搜索去走全部
            if (this.config.dataType === 'customize') {
                // 这时候拿的数据是配置里面的
                const reg = new RegExp(key)
                const list = this.setSearch(JSON.parse(JSON.stringify(this.config.levelConfig)), reg)
                // this.$set(this, 'levelConfig', list)
                this.levelConfig = list
            }
        },
        setSearch (arr, key) {
            const a = []
            for (const i of arr) {
                const rg = i.label.match(key)
                if (i.children && i.children.length > 0) {
                    const list = this.setSearch(i.children, key)
                    i.children = list
                }
                if (rg || i.children && i.children.length > 0) a.push(i)
            }
            return a
        },
        getHide (config, key) {
            if (this.config.dataType === 'provinces' && (this.search || this.search === 0) && key === this.config.level) {
                const reg = new RegExp(this.search)
                return (config.label || '').match(reg)
            }
            return true
        },
        getShowVal (val) {
            console.log("val==",val);
            
            if (!val) return this.placeholder
            if (!this.config.levelConfig || this.config.levelConfig.length === 0) return val
            const s = val.split(',')
            const e = []
            let config = JSON.parse(JSON.stringify(this.config.levelConfig))
            if (this.config.dataType === 'provinces') {
                for (const i of s) {
                    if (config[i]) {
                        e.push(config[i].label)
                        config = config[i].children
                    } else {
                        e.push(i)
                    }
                }
                return e.join(',')
            } else {
                for (const i of s) {
                    const a = config.findIndex(it => it.value === i)
                    if (a !== -1) {
                        e.push(config[a].label)
                        config = config[a].children
                    } else {
                        e.push(i)
                    }
                }
                return e.join(',')
            }
        },
        async setActive (key, index, config, isInit = false) {
            this[key] = index
            if (isInit) {
              this.$nextTick(() => {
                const wrap = this.$refs[key + 'Ref']?.$el?.querySelector('.el-scrollbar__wrap');
                if (!wrap) return;
                // 找到当前激活的 DOM 元素（通过类名或索引）
                const activeItem = wrap.querySelector('.m-list-active');
                if (activeItem) {
                  wrap.scrollTop = activeItem.offsetTop - wrap.offsetTop - 10; // 留点边距
                }
              });
            }
            // 级别选择重置下面的
            switch (key) {
                case 'oneActive':
                    this.twoActive = ''
                    this.threeActive = ''
                    break
                case 'twoActive':
                    this.threeActive = ''
                    break
            }
            // 省市的
            if (this.config.dataType === 'provinces' && (key !== 'threeActive' || !(this.config.level === 2 && key === 'twoActive'))) {
                console.log('拦截的')
                const list = await this.getProvinces(config.code)
                // this.$set(config, 'children', list)
                config.children = list
                if (isInit) {
                  const val = this.radioValue[1]
                  const index = list.findIndex(iten => { return iten.name === val })
                  if (index !== -1) {
                    this.setActive('twoActive', index, config.children[index], true)
                  }
                  if (key === 'twoActive') {
                    return false
                  }
                }
            }
            // 如果当前没有下级，他就是最终级别
            const ee = {
                twoActive: 2,
                threeActive: 3
            }
            if (!config.children || config.children.length === 0 || ee[key] === this.config.level) {
                const o = ['oneActive', 'twoActive', 'threeActive']
                const s = []
                let b = ''
                for (const i of o) {
                    b = !b ? this.levelConfig[this.oneActive] : b.children[this[i]]
                    if (i === key) {
                        s.push(config.value)
                        break
                    }
                    if (b) s.push(b.value)
                }
                console.log('确认的最终', s)
                this.radioValue = s
                this.$emit('update:formdata', s.join(','))
                this.$refs.but.click()
                this.$emit('change', s.join(','))
            }
        },
        // 打开下级时，解析当前选中和下拉等数据
        async showFun () {
            console.log('showFun', this.show)
            if (!this.config || !this.config.dataType) {
                this.levelConfig = []
                return false
            }
            const w = this.$refs.multilevel.getBoundingClientRect()
            // this.$set(this, 'width', (w.width - 24) + 'px')
            this.width = w.width - 24
            await this.$nextTick()
            const val = (this.formdata || '').split(',')
            // this.$set(this, 'radioValue', val)
            this.radioValue = val
            if (this.config.dataType === 'provinces') {
                if (!this.levelConfig || this.levelConfig.length === 0) {
                    // 加载省市数据
                    const list = await this.getProvinces(0)
                    this.levelConfig = list
                    // 设置初始化一级选中的
                    const val = this.radioValue[0]
                    const index = this.levelConfig.findIndex(iten => { return iten.name === val })
                    if (index !== -1) {
                      await this.setActive('oneActive', index, this.levelConfig[index], true)
                    }
                    // this.$set(this, 'levelConfig', list)
                }
            } else {
                // this.$set(this, 'levelConfig', JSON.parse(JSON.stringify(this.config.levelConfig)))
                this.levelConfig = JSON.parse(JSON.stringify(this.config.levelConfig))
            }
            
            this.show = true

        },
        async getProvinces (id) {
            const { code, data, msg } = await getregiondictlist({ parentCode: id, curpage: 1, pagesize: 99999 }).catch(err => { console.log(err) })
            if (code === 0) {
                // 字段匹配
                let o = JSON.parse(JSON.stringify(this.config.levelConfig))
                if (data[0] && data[0].level) {
                    switch (Number(data[0].level)) {
                        case 2: {
                            const s = this.levelConfig[this.oneActive] && this.levelConfig[this.oneActive].value
                            if (s || s === 0) o = o && o[s] && o[s].children
                            break
                        }
                        case 3: {
                            const s1 = this.levelConfig[this.oneActive] && this.levelConfig[this.oneActive].value
                            const s12 = this.levelConfig[this.oneActive] && this.levelConfig[this.oneActive].children[this.twoActive] && this.levelConfig[this.oneActive].children[this.twoActive].value
                            if ((s1 || s1 === 0) && (s12 || s12 === 0)) o = o && o[s1] && o[s1].children[s12].children
                            break
                        }
                    }
                }
                return data.map(it => {
                    it.value = it.name
                    it.label = o && o[it.name] ? o[it.name].label : it.name
                    it.locking = o && o[it.name] ? o[it.name].locking : true
                    it.isHide = o && o[it.name] ? o[it.name].isHide : false
                    return it
                })
            } else {
                this.$message.error(msg || '省市查询失败')
                return []
            }
        },
    }
}
</script>

<style scoped lang="scss">
    .m-no-c {
        color: #bdbdbd;
        margin-left: -10px;
    }
    .icon-b {
        color: #bdbdbd;
    }
    .m-popover {
        :deep(.m-popover-search) {
            border-bottom: 1px solid #DEDFE5;
            margin-left: -12px;
            margin-right: -12px;
            padding-left: 12px;
            padding-right: 12px;
            padding-bottom: 12px;
            .el-input--small .el-input__wrapper {
                height: 32px;
                line-height: 32px;
                border-radius: 16px;
                font-size: 14px;
            }
        }
        :deep(.m-scroll) {
            height: 200px;
            display: flex;
            align-items: flex-start;
            margin-left: -12px;
            margin-right: -12px;
            margin-bottom: -8px;
            .m-s-s {
                flex: 1;
                border-right: 1px solid #DEDFE5;
                padding-top: 4px;
                height: 100%;
                .m-list {
                    color: #666666;
                    font-size: 14px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    line-height: 32px;
                    padding-left: 12px;
                    padding-right: 12px;
                    cursor: pointer;
                }
                .m-list-active {
                    background-color: #F6F7FA;
                    color: #4E87FF;
                }
            }
        }
        :deep(.m-no-data) {
            color: #666666;
            height: 30px;
            padding-top: 10px;
            text-align: center;
        }
    }

    .multilevel {
        width: 100%;
        .m-select {
            border: 1px solid #DEDFE5;
            border-radius: 4px;
            min-height: 40px;
            padding-left: 12px;
            padding-right: 12px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: #FFFFFF;
            .m-value {
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-radius: 4px;
                background-color: #4E87FF;
                color: #FFFFFF;
                font-size: 14px;
                line-height: 18px;
                padding: 7px 10px;
                i {
                    margin-left: 10px;
                    cursor: pointer;
                    transition: 0.3s;
                }
            }
        }
        .show-i {
            color: #4E87FF;
            transform: rotate(180deg);
        }
    }
</style>